import React, { useEffect, useState } from "react";
import { Card, CardBody } from "reactstrap";
import image2 from "../../assets/profile/male-icon.png";
import { useDispatch, useSelector } from "react-redux";
import NotifiyCard from "../../Components/NotifiyCard";
import femaleIcon from "../../assets/profile/female-icon.png";
import maleIcon from "../../assets/profile/user.jpeg";
import BreadCrumb from "../../Components/BreadCrumbComp";
import { MessageCircle, MessageSquare } from "react-feather";
import { NotificationAction } from "../../Store/Actions/NotificationAction";
import moment from "moment";
import NoDataFound from "../../Components/NoDataFound";
import PostApiCall from "../../Api/Api";
import { useSocket } from "../../Helper/Socket";
import { timeAgo } from "../../Helper/GetTime";
import { formatDate } from "../../Helper/GetDays";

const Notification = () => {
  const user = useSelector((state) => state.login);
  const { notifyData } = useSelector((state) => state.notify);

  // Socket Server Start
  const [notifications, setNotifications] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const socket = useSocket();
  useEffect(() => {
    if (socket) {
      socket.emit("FetchNotificationData");
      socket.on("GetNotificationData", (data) => {
        setNotifications(data);
      });
    }
    socket.on("PushNotification", () => {
      socket.emit("FetchNotificationData");
    });
  }, [socket]);

  useEffect(() => {
    const UpdateNotificationStatus = async () => {
      const payload = {
        userid: user.fld_id,
        usertype: user.fld_usertype === "Staff" ? "Admin" : user.fld_usertype,
      };
      const dd = await PostApiCall.postRequest(
        payload,
        "UpdateNotificationStatus"
      );
    };
    UpdateNotificationStatus();
  }, []);
  const groupNotificationsByDate = (notifications) => {
    // const today = new Date();
    // const yesterday = new Date(today);
    // yesterday.setDate(yesterday.getDate() - 1);
    // const todayStr = formatDate(today);
    // const yesterdayStr = formatDate(yesterday);

    const grouped = notifications.reduce(
      (acc, notification) => {
        const notificationDate = formatDate(notification.fld_createdat);
        if (notificationDate === "today") {
          acc.today(notification);
        } else if (notificationDate === "yesterday") {
          acc.yesterday(notification);
        } else {
          acc.previous(notification);
        }
        return acc;
      },
      { today: [], yesterday: [], previous: [] }
    );

    return grouped;
  };

  const groupedNotifications = groupNotificationsByDate(notifications);

  return (
    <div className="App"style={{ minHeight: "100vh" }}>
      <section className="section mx-md-5 mx-3 px-md-4">
        <div className="w-100 mt-5">
          <BreadCrumb icon={true} subitem="Notification" />
        </div>
        {notifications?.length > 0 ? (
          <>
            {groupedNotifications.today.length > 0 && (
              <div>
                <Heading heading="Today" />
                {groupedNotifications.today?.map((i, index) => {
                  return <NotificationCard key={index} notification={i} />;
                })}
              </div>
            )}
            {groupedNotifications.yesterday.length > 0 && (
              <div className="">
                <Heading heading={"Yesterday"} />
                {groupedNotifications.yesterday?.map((i, index) => {
                  return <NotificationCard key={index} notification={i} />;
                })}
              </div>
            )}
            {groupedNotifications.previous.length > 0 && (
              <div>
                <Heading heading={"Previous"} />
                {groupedNotifications.previous?.map((i, index) => {
                  return <NotificationCard key={index} notification={i} />;
                })}
              </div>
            )}
          </>
        ) : (
          <NoDataFound />
        )}
      </section>
    </div>
  );
};
const Heading = ({ heading }) => {
  return (
    <div className="d-flex align-items-center justify-content-center">
      <span className="border" style={{ width: "100px" }}></span>
      <span className="mx-2" style={{ fontSize: "12px" }}>
        {heading}
      </span>
      <span className="border" style={{ width: "100px" }}></span>
    </div>
  );
};
const NotificationCard = ({ notification }) => {
  return (
    <>
      <a href={notification.fld_linkurl}>
        <Card className="mb-2 shadow notificationCard">
          <div className="d-md-flex justify-content-between flex-wrap  py-2 px-2">
            <div className="avatar avatar-sm d-flex align-items-center">
              <img
                src={
                  process.env.REACT_APP_FILE_PATH_URL + notification?.fld_photo
                }
                alt=""
                className="mr-2 shadow"
                style={{
                  width: "35px",
                  height: "35px",
                }}
                onError={(e) => (e.target.src = maleIcon)}
              />

              <div>
                <p className="ml-md-5 text-dark">{notification.fld_title}</p>
                <p className="ml-md-5 font-size-3">
                  {notification.fld_message}
                </p>
              </div>
            </div>

            <div className="font-size-3 text-right">
              {timeAgo(notification.fld_createdat)}
            </div>
          </div>
        </Card>
      </a>
    </>
  );
};

export default Notification;
